<template>
  <!-- <v-alert type="error" dismissible @input="dismiss" :value="!!this.$store.state.error">
    {{ this.$store.state.error }}
  </v-alert>-->
  <v-snackbar
    :color="this.$store.state.snackbarColor"
    :value="!!$store.state.snackbar"
    @input="dismiss"
    :top="true"
    :timeout="10000"
  >
    {{ adjustedMessage }}
    <v-btn dark text @click="dismiss">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: "ErrorMessage",
  computed: {
    adjustedMessage: function() {
      return this.$store.state.error === "Request failed with status code 401"
        ? "Authentication has timed out. Please login."
        : this.$store.state.error;
    }
  },
  methods: {
    dismiss() {
      console.log("im dismissed");
      this.$store.state.snackbar = false;
      this.$store.state.error = "";
      this.$store.state.snackbarColor = "error";
    }
  }
};
</script>
